import { actions as userActions } from "../user";
import {
  actions as routerActions,
  selectors as routerSelectors
} from "../router/";
import { sendNativeMessage } from "../../ui/utils/native";
import {
  MERGE_ACCOUNT_FAILURE,
  RESEND_ACTIVATION_EMAIL_FAILURE,
  UPDATE_FORGOTTEN_PASSWORD_FAILURE,
  RESET_PASSWORD_FAILURE
} from "../user/types";
/**
 * If an action comes through with an error that has a code of 401, dispatch
 * the user logout action which will clear user data and effectively redirect
 * to signin.
 */

// We don't want to redirect in some cases, so ignore it.
const ignoreActions = [
  MERGE_ACCOUNT_FAILURE,
  RESEND_ACTIVATION_EMAIL_FAILURE,
  UPDATE_FORGOTTEN_PASSWORD_FAILURE,
  RESET_PASSWORD_FAILURE
];

export default store => next => action => {
  if (ignoreActions.indexOf(action.type) !== -1) {
    return next(action);
  }

  if (action.error && action.error.code === 401) {
    const state = store.getState();
    if (routerSelectors.isNative(state)) {
      const platform = routerSelectors.getQueryParam(state, "platform");
      const route = routerSelectors.getCurrentRoute(state);
      sendNativeMessage(platform, "user:signout", {
        error: action.error,
        route
      });
    } else {
      store.dispatch(userActions.userSignedOut());
    }
  }

  // Do not redirect if redemption code is invalid or any 422 or 404
  // These should be handled by the code and not redirect
  // Only redirects in the case of redeem code
  if (action.error && action.error.code && action.error.code !== 422) {
    Fraction.Reporter.noticeError(
      `Error Redirect: ${action.type} ${action.error.code}`
    );
    store.dispatch(routerActions.go(`system-error/${action.error.code}`));
  }
  next(action);
};
